import React, { useEffect, useState } from 'react';
import './Modal.css';

export default function Modal({ isOpen, onClose, title, children }) {
  const [show, setShow] = useState(false);
  const [animateOut, setAnimateOut] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setShow(true);
      setAnimateOut(false);
      document.body.style.overflow = 'hidden'; // Disable background scroll
    } else {
      setAnimateOut(true);
      document.body.style.overflow = ''; // Enable background scroll
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const handleAnimationEnd = () => {
    if (animateOut) {
      setShow(false);
      setAnimateOut(false);
    }
  };

  if (!show) return null;

  // Click on overlay closes modal
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className={`modal__overlay ${animateOut ? 'fadeOutOverlay' : 'fadeInOverlay'}`}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modalTitle"
      onAnimationEnd={handleAnimationEnd}
      onClick={handleOverlayClick} // <-- overlay click handler
    >
      <div
        className={`modal__container ${animateOut ? 'fadeOutModal' : 'fadeInModal'}`}
      >
        <div className="modal__header">
          <h2 id="modalTitle">{title}</h2>
          <button className="modal__close" onClick={onClose} aria-label="Close modal">
            &times;
          </button>
        </div>
        <div className="modal__content">{children}</div>
      </div>
    </div>
  );
}
